export const APP_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.talkingalarmclock";
